import React, { useEffect, useState } from 'react';
import { TouchableWithoutFeedback } from 'react-native';

import { Form } from 'antd';
import cn from 'classnames';

import CountrySelect from '@components/CountrySelect'
import { Icon } from '@components/index'
import PWDValidateModal, { passwordValidator } from '@components/PWDValidateModal';
import RadioButton from '@components/RadioButton/RadioButton';
import { THEME, USER_AGREEMENT } from '@constants/index'
import { Button, Input, InputPassword, Popover } from '@element/index';
import { useIsomorphicLayoutEffect, useRemoteConfigValue } from '@lib/hooks';
import I18n from '@utils/i18n';

import styles from './index.module.css';
import registerStyles from '@styles/modules/register.module.css';
const FormItem = Form.Item;

export default function MobileRegister (props) {
  const { code, showInviteCode = true, btnText, btnClass, bottomClass, theme } = props
  const [form] = Form.useForm();

  const [isCollapse, setCollapse] = useState(false);
  const whiteList = useRemoteConfigValue('white_list_countries')

  useIsomorphicLayoutEffect(() => {
    if (props.initValue && form) {
      form.setFieldsValue({ mobile: props.initValue })
    }
    if (props.ic && form) {
      setCollapse(true)
      form.setFieldsValue({ inviteCode: props.ic })
    }
  }, [form, props])

  useEffect(() => {
    if (code) {
      setCollapse(true)
      // form.setFields({ inviteCode: code })
    }
  }, [code])

  const handleSubmit = () => {
    const { mobile, password, inviteCode, country } = form.getFieldsValue()
    const params = {
      mobile,
      countryNum: country.telephoneCode,
      country: country.id,
      pwd: password,
      inviteCode
    };
    props.handleSubmit && props.handleSubmit(params);
  }

  function onToggleCollapse () {
    setCollapse(!isCollapse)
  }

  const onCountryChange = (option) => {
    form.setFieldsValue({
      country: {
        id: option.id,
        telephoneCode: option.telephoneCode
      }
    })
  }

  const onCountrySearch = (val) => {
    // console.log('search:', val);
  }
  return (
    <div className={registerStyles.container}>
      <Form
        name='complex-form'
        wrapperCol={{ span: 24 }}
        onFinish={handleSubmit}
        // onFinishFailed={onFinishFailed}
        autoComplete='off'
        layout='vertical'
        form={form}
        initialValues={{
          remember: true,
          country: { id: 'HK', telephoneCode: '852' },
          mobile: '',
          password: '',
          isRadioChecked: false,
          inviteCode: ''
        }}
      >
        <div className={registerStyles.flexRow + ' mb8'}>
          <span className={registerStyles.countryCode}>
            <FormItem
              className={registerStyles.country}
              name='country'
            >
              <CountrySelect
                showCountryCode={true}
                onChange={onCountryChange}
                onSearch={onCountrySearch}
                whiteList={whiteList}
                searchListScrollBottomTip={I18n.t('rxsNAfb6')}
                theme={theme}
              />
            </FormItem>
          </span>
          <span className={registerStyles.mobile}>
            <FormItem
              name='mobile'
              rules={[
                // ({ getFieldValue }) => ({
                //   validator (_, value) {
                //     return mobileValidator(value);
                //   }
                // })
                {
                  required: true,
                  message: I18n.t('register_mobile_is_require')
                },
                {
                  whitespace: true,
                  message: I18n.t('register_mobile_is_require')
                }
              ]}
            >
              <Input
                showClear={true}
                theme={theme}
                placeholder={I18n.t('register_input_mobile')}
                autocomplete="off"
              />
            </FormItem>
          </span>
        </div>
        <FormItem
          className='register-password-form'
          shouldUpdate
        >
          {(form) => {
            const { password } = form.getFieldsValue()
            return (
              <Popover
                placement="bottomLeft"
                content={(<PWDValidateModal password={password} theme={theme} />)}
                trigger='click'
                color='#fff'
              >
                <FormItem
                  name='password'
                  rules={[
                    ({ getFieldValue }) => ({
                      validator (_, value) {
                        return passwordValidator(value);
                      }
                    })
                  ]}
                >
                  <InputPassword
                    name='password'
                    type='password'
                    theme={theme}
                    placeholder={I18n.t('register_input_password')}
                    maxLength={20}
                    showClear={true}
                    autocomplete="new-password"
                  />
                </FormItem>
              </Popover>)
          }}
        </FormItem>
        {showInviteCode ? <TouchableWithoutFeedback onPress={onToggleCollapse}>
          <div className={registerStyles.inviteCode + ` ${isCollapse ? 'mb4' : 'mb48'}`}>
            <p className={cn(registerStyles.inviteCodeLabel, {
              [styles.darkInviteCodeLabel]: theme === THEME.DARK
            })}>{I18n.t('register_invitecode')}</p>
            <Icon className={cn(styles.arrow, {
              [styles.up]: isCollapse,
              [styles.down]: !isCollapse,
              [styles.darkArrow]: theme === THEME.DARK
            })} name="arrow-line" />

          </div>
        </TouchableWithoutFeedback> : null}
        {
          isCollapse
            ? <FormItem
              name='inviteCode'
              className='mb48'
            >
              <Input
                showClear={true}
                theme={theme}
                placeholder={I18n.t('register_input_invitecode')}
              />
            </FormItem>
            : null
        }
        <div className={bottomClass}>
        <FormItem shouldUpdate>
          {(form) => {
            const isRadioChecked = form.getFieldValue('isRadioChecked');
            return (
              <FormItem name="isRadioChecked" initialValue={false}>
                <RadioButton
                  isRadioChecked={isRadioChecked}
                  onChange={() => {
                    form.setFieldsValue({ isRadioChecked: !isRadioChecked })
                  }}
                  theme={theme}
                  radioText={I18n.t('register_agree_protocol')}
                  linkUrl={USER_AGREEMENT[I18n.locale]}
                  linkContent={I18n.t('register_kiki_protocol')}
                  linkAfterContent={I18n.t('Kikitrade.policy')}
                />
              </FormItem>
            )
          }}
        </FormItem>
        <FormItem shouldUpdate>
          {(form) => {
            const { mobile, password, isRadioChecked } = form.getFieldsValue()
            const errors = form.getFieldsError(['password', 'mobile'])?.reduce((prev, curr) => {
              prev.push(...curr.errors)
              return prev;
            }, []);
            return (
              <Button
                type='primary'
                htmlType='submit'
                disabled={!(mobile && password && isRadioChecked && !errors.length)}
                loading={props.registering}
                data-buried="register"
                data-buried-type="register-mobile"
                className={cn(btnClass)}
                content={<span className={cn('Medium')}>{btnText || I18n.t('register')}</span>}
              />)
          }}
        </FormItem>
        </div>
      </Form>
    </div>
  )
}
